import { notificationTypes } from 'project/general';

const notificationLabels = {};
notificationLabels[notificationTypes.SUCCESS] = 'Success!';
notificationLabels[notificationTypes.ERROR] = '';
notificationLabels[notificationTypes.WARNING] = 'Warning!';
notificationLabels[notificationTypes.INFO] = 'Info';
export { notificationLabels };
